import { render } from "./FileManagerOptions.vue?vue&type=template&id=cc2c442c"
import script from "./FileManagerOptions.vue?vue&type=script&lang=js"
export * from "./FileManagerOptions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__